<template>
  <div class="box6">
    <pageTitle title="知名校友" />
    <div class="subject-box">
      <div class="pic-nav-box">
        <div
          class="nav"
          v-for="(item, index) in list"
          :key="index"
          :class="{ 'cur-nav': cur == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <img :src="item.pic" />
        </div>
        
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="box">
            <img :src="item.bgPic" alt="" />
            <div class="title">{{ item.name }}</div>
            <div class="tag">{{ item.tag }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: 1,
        // spaceBetween: 20,
        centeredSlides: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
        //   disableOnInteraction: false,
        // },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("pic-nav-box")[0].scrollLeft =
              this.realIndex * 100;
          }
        },
      },
      list:  [
        {
          name: "孙穗芳",
          tag: "孙中山先生孙女",
          text: "孙中山和平教育基金会主席，夏威夷中国妇女慈善会会长，夏威夷太平洋大学校董，中山大学香港校友会名誉会长，深圳孙中山医院的创办人。",
          pic: require("../../../assets/coursePage/hawai/box6/pic1.png"), 
          bgPic: require("../../../assets/coursePage/hawai/box6/bgpic1.png"),
        },
        {
          name: "邬君梅",
          tag: "著名华语影视女演员、制片人",
          text: "奥斯卡金像奖终身评委，曾数次担任国际艾美奖、东京国际电影节等国际A类电影节评委，现任中美电影节委员会委员。",
          pic: require("../../../assets/coursePage/hawai/box6/pic2.png"), 
          bgPic: require("../../../assets/coursePage/hawai/box6/bgpic2.png"),
        },
        {
          name: "Sarah Palin",
          tag: "美国记者、阿拉斯加州州长",
          text: "美国阿拉斯加州历史上最年轻的州长。2008年共和党副总统候选人，麦凯恩的竞选伙伴，美国历史上第一个共和党的女性副总统候选人。",
          pic: require("../../../assets/coursePage/hawai/box6/pic3.png"), 
          bgPic: require("../../../assets/coursePage/hawai/box6/bgpic3.png"),
        },
        {
          name: "Christopher Loeak",
          tag: "马绍尔群岛共和国总统",
          text: "先后担任过马绍尔群岛共和国司法部长、社会事务部长、教育部长和总统助理部长，后任马绍尔群岛共和国总统。",
          pic: require("../../../assets/coursePage/hawai/box6/pic4.png"), 
          bgPic: require("../../../assets/coursePage/hawai/box6/bgpic4.png"),
        },
      ],
      cur: 0,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  font-family: PingFangSC, PingFang SC;
  padding: 80px 0;
  width: 100%;
  background: #F3F7F9;
  box-sizing: border-box;
  /deep/.course-title-box .course-title {
    font-weight: 600;
    font-size: 44px;
    color: #122A4F;
    line-height: 64px;
    text-align: center;
  }
  .subject-box {
    box-sizing: border-box;
    padding: 0 40px;
    position: relative;
    margin: 48px auto 0;
    overflow: hidden;
    .pic-nav-box::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }

    .pic-nav-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .nav {
        overflow: hidden;
        border-radius: 6px;
        border: 3px solid #fff;
        img {
          display: block;
          width: 152px;
          height: 152px;
        }
      }
      .cur-nav {
        border: 3px solid #0084A7;
        border-radius: 6px;
      }
    }
    .swiper-container{
      padding: 40px 0 0;
    }
    .swiper-slide {
      position: relative;
      width: 670px;
      height: 332px;
      background: #FFFFFF;
      border-radius: 24px;
      padding: 40px;
      box-sizing: border-box;
      .box {
        img {
          z-index: 0;
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          width: 248px;
          height: 268px;
        }
      }
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 40px;
        color: #272020;
        line-height: 56px;
        text-align: left;
        display: flex;
        align-items: center;
      }
      .tag {
        box-sizing: border-box;
        width: 460px;
        margin: 12px 0 0;
        background: linear-gradient( 270deg, rgba(0,186,211,0) 0%, rgba(0,132,167,0.1) 100%);
        border-radius: 8px;
        padding: 0 16px;
        font-size: 26px;
        color: #1D82A3;
        line-height: 48px;
      }
      .text {
        position: relative;
        z-index: 1;
        margin-top: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #122A4F;
        line-height: 40px;
        text-align: left;
      }
      img {
        width: 558px;
        height: 380px;
      }
    }
  }
}
</style>
